import React from "react";
import { useSwiper } from "swiper/react";
import BaseGameActionButton from "../../../components/GameActionButtons";
import "./style.scss";
import PropTypes from "prop-types";
export default function PrevSlideBtn({ isOneSlide }) {
  PrevSlideBtn.propTypes = {
    isOneSlide: PropTypes.bool,
  };
  const swiper = useSwiper();
  return (
    <BaseGameActionButton
      className={`prev-slide-btn ${isOneSlide && "btn-one-slide"}`}
      onClick={() => swiper.slidePrev()}
      type="back"
    />
  );
}
